import { useState, useEffect, useCallback } from "react";
import ExitPopup from "./ExitPopup.jsx";
import Cookies from "js-cookie";
import { useWindowSize } from "../../hooks.js";

const ExitBanner = () => {
  const [isOpen, setOpen] = useState(false);
  const dismissed = Cookies.get("exit_banner");

  const [vpWidth] = useWindowSize();

  const handleMouseOutEvent = useCallback(
    (evt) => {
      if (dismissed) {
        return;
      }
      if (evt) {
        if (vpWidth < 992) return;
        if (evt.clientX >= vpWidth) return;
        if (evt.clientY >= 50) return;

        setOpen(true);
      }
    },
    [vpWidth, dismissed],
  );

  useEffect(() => {
    if (vpWidth < 992 && isOpen) {
      setOpen(false);
    }
  }, [vpWidth, isOpen]);

  const onDismiss = useCallback(() => {
    setOpen(false);
    Cookies.set("exit_banner", 1, { expires: 7 });
  }, []);

  useEffect(() => {
    document.body.addEventListener("mouseout", handleMouseOutEvent);
    return () => {
      document.body.removeEventListener("mouseout", handleMouseOutEvent);
    };
  }, [handleMouseOutEvent]);

  return <ExitPopup isOpen={isOpen} onClose={() => onDismiss()} />;
};

export default ExitBanner;
